// src/App.js

import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import FocusHelper from './FocusHelper';
import EventDetails from './EventDetails';
import './App.css';
import Icon from '@mdi/react';
import { mdiRobotDeadOutline } from '@mdi/js';

const App = () => {
  const [selectedEvent, setSelectedEvent] = useState(null); // Track selected event
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get('user_id');
  const handleEventSelect = (event) => {
    console.log("Selected event in App:", event);
    setSelectedEvent(event); // Set the selected event
  };
  return (
    <div style={{ padding: '5vh', paddingBottom: '20vh' }}>
      <h3 className="title">F<Icon path={mdiRobotDeadOutline} size={1.2} />cus Helper </h3>
      {!selectedEvent && (
        <FocusHelper onEventSelect={handleEventSelect}  />
      )}
     
      {selectedEvent && (
        <EventDetails
          event={selectedEvent}
          userId={userId}
          onBack={() => {
            setSelectedEvent(null); // Reset selected event when going back
          }}
        />
      )}
    </div>
  );
};

export default App;
